"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _formik = require("formik");

var _propTypes = require("prop-types");

var _lodash = _interopRequireDefault(require("lodash.map"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var ErrorComp = _styledComponents.default.div(_templateObject(), _colors.default.error);

ErrorComp.displayName = 'ErrorComp';

var FormikValidation = function FormikValidation(_ref) {
  var name = _ref.name;
  return _react.default.createElement(_formik.ErrorMessage, {
    name: name,
    component: function component(_ref2) {
      var children = _ref2.children;
      return _react.default.createElement(ErrorComp, null, (0, _lodash.default)(children, function (v) {
        return v;
      }));
    }
  });
};

FormikValidation.propTypes = {
  name: _propTypes.string.isRequired
};
var _default = FormikValidation;
exports.default = _default;